import { tokens } from '../../theme';
import type { MilestoneStatus } from '../../data/types';

export interface StatusMeta {
  bar: string;
  label: string;
  pill: { bg: string; color: string };
}

export function statusMeta(status: MilestoneStatus, accent: string, accentInk: string): StatusMeta {
  if (status === 'done') {
    return {
      bar: accent,
      label: 'Achieved',
      pill: { bg: `color-mix(in oklch, ${accent} 12%, ${tokens.bg})`, color: accentInk },
    };
  }
  if (status === 'now') {
    return { bar: tokens.amber, label: 'In progress', pill: { bg: tokens.amberSoft, color: '#8B6A1F' } };
  }
  return { bar: tokens.grey, label: 'Upcoming', pill: { bg: tokens.greySoft, color: tokens.ink2 } };
}

/** Calendar date `weeks` after the baby's birth, formatted as e.g. "Aug 5". */
function dateFromWeeks(dobIso: string, weeks: number): string {
  const d = new Date(dobIso + 'T00:00:00Z');
  d.setUTCDate(d.getUTCDate() + Math.round(weeks * 7));
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
}

/**
 * "Usually starts" summary in calendar weeks, with the real dates those weeks
 * fall on (computed from the baby's birthdate) in brackets when available.
 *   with dob:    Usually starts wk 6–10 (Jul 22 – Aug 19) · median wk 8 (Aug 5)
 *   without dob: Usually starts wk 6–10 · median wk 8
 */
export function fmtRange(
  startWeeks: number,
  endWeeks: number,
  medianWeeks: number,
  dobIso?: string,
): string {
  const wk = (w: number) => `${Math.round(w)}`;
  const range = `Usually starts wk ${wk(startWeeks)}–${wk(endWeeks)}`;
  const median = `median wk ${wk(medianWeeks)}`;
  if (!dobIso) return `${range} · ${median}`;
  const startEnd = `${dateFromWeeks(dobIso, startWeeks)} – ${dateFromWeeks(dobIso, endWeeks)}`;
  return `${range} (${startEnd}) · ${median} (${dateFromWeeks(dobIso, medianWeeks)})`;
}
